/**
 * Bloco Prescrição:
 * - suporte a campos condicionais por tipo de lente
 * - validação de obrigatórios antes do add-to-cart
 * - envio separado OD/OE ou combinado em "mesmo grau"
 */
(function () {
  const CART_UPDATE = 'cart:update';
  const DATA_PRESCRIPTION_INJECTED = 'data-prescription-injected';

  function initGrauPickers(root) {
    root.querySelectorAll('.jv-prescription-grau').forEach((picker) => {
      const trigger = picker.querySelector('[data-grau-trigger]');
      const dropdown = picker.querySelector('[data-grau-dropdown]');
      const label = picker.querySelector('[data-grau-label]');
      const input = picker.querySelector('[data-grau-input]');
      if (!trigger || !dropdown || !input) return;

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = !dropdown.hidden;
        dropdown.hidden = isOpen;
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) {
          document.removeEventListener('click', closeThis);
        } else {
          setTimeout(() => document.addEventListener('click', closeThis), 0);
        }
      });

      function closeThis() {
        dropdown.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', closeThis);
      }

      picker.querySelectorAll('[data-grau-value]').forEach((opt) => {
        opt.addEventListener('click', (e) => {
          e.stopPropagation();
          const value = opt.getAttribute('data-grau-value');
          const display = opt.getAttribute('data-grau-display') || value;
          input.value = value;
          input.disabled = false;
          if (label) label.textContent = display;
          dropdown.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          document.removeEventListener('click', closeThis);
        });
      });
    });
  }

  function initHeaderTooltipPosition(root) {
    const wrap = root.querySelector('.jv-prescription__tooltip-wrap--header');
    if (!wrap) return;
    const btn = wrap.querySelector('.jv-prescription__tooltip-btn');
    const content = wrap.querySelector('.jv-prescription__tooltip-content--below');
    if (!btn || !content) return;

    function positionTooltip() {
      const rect = btn.getBoundingClientRect();
      wrap.style.setProperty('--tooltip-left', rect.left + 'px');
      wrap.style.setProperty('--tooltip-top', rect.bottom + 4 + 'px');
      wrap.classList.add('jv-prescription__tooltip-wrap--positioned');
    }

    function clearPosition() {
      wrap.classList.remove('jv-prescription__tooltip-wrap--positioned');
    }

    btn.addEventListener('mouseenter', positionTooltip);
    btn.addEventListener('focusin', positionTooltip);
    content.addEventListener('mouseenter', positionTooltip);
    btn.addEventListener('mouseleave', () => setTimeout(clearPosition, 200));
    content.addEventListener('mouseleave', () => setTimeout(clearPosition, 200));
    btn.addEventListener('focusout', () => setTimeout(clearPosition, 150));
  }

  function injectPrescriptionIntoForm(form, root) {
    const injected = form.querySelectorAll('[' + DATA_PRESCRIPTION_INJECTED + ']');
    injected.forEach((el) => el.remove());

    const qtyEl = root.querySelector('[data-prescription-quantity]');
    const formQty = form.querySelector('input[name="quantity"]');
    if (formQty && qtyEl) {
      formQty.value = qtyEl.value;
    } else if (qtyEl) {
      const inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'quantity';
      inp.value = qtyEl.value;
      inp.setAttribute(DATA_PRESCRIPTION_INJECTED, '1');
      form.appendChild(inp);
    }

    root.querySelectorAll('[data-prescription-prop]:not([disabled])').forEach((el) => {
      if (el.name && el.value) {
        const inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = el.name;
        inp.value = el.value;
        inp.setAttribute(DATA_PRESCRIPTION_INJECTED, '1');
        form.appendChild(inp);
      }
    });
  }

  function initFormInject(root) {
    const section = root.closest('[data-section-id]') || root.closest('section');
    if (!section) return;
    const form = section.querySelector('form[data-type="add-to-cart-form"]') || section.querySelector('product-form-component form');
    if (!form) return;

    form.addEventListener(
      'submit',
      () => {
        injectPrescriptionIntoForm(form, root);
      },
      true
    );
  }

  function getVariantId(root) {
    const section = root.closest('[data-section-id]') || root.closest('section');
    if (section) {
      const form = section.querySelector('form[data-type="add-to-cart-form"]') || section.querySelector('product-form-component form');
      const idInput = form && form.querySelector('input[name="id"]');
      if (idInput && idInput.value) return idInput.value;
    }
    return root.dataset.variantId || '';
  }

  function getScopeFields(root, scope) {
    const scopeEl = root.querySelector('[data-prescription-scope="' + scope + '"]');
    if (!scopeEl) return [];
    return Array.from(scopeEl.querySelectorAll('[data-prescription-prop]:not([disabled])'));
  }

  function validateFields(fields, message) {
    const invalid = fields.find((el) => el.hasAttribute('data-prescription-required') && !String(el.value || '').trim());
    if (!invalid) return true;
    if (typeof window.alert === 'function') window.alert(message);
    if (typeof invalid.focus === 'function') invalid.focus();
    return false;
  }

  function buildFormData(variantId, quantity, fields) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(Math.max(1, quantity)));
    fields.forEach((el) => {
      if (el.name && el.value) {
        formData.append(el.name, el.value);
      }
    });
    return formData;
  }

  function fetchSectionsAndDispatch(root, totalItemCount) {
    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    function dispatch(sectionsPayload) {
      const eventDetail = {
        resource: {},
        sourceId: root.id || 'jv-prescription',
        data: sectionsPayload ? { sections: sectionsPayload } : {}
      };
      if (totalItemCount != null) {
        eventDetail.data.itemCount = totalItemCount;
        eventDetail.data.source = 'product-form-component';
      }
      document.dispatchEvent(new CustomEvent(CART_UPDATE, { bubbles: true, detail: eventDetail }));
    }

    if (sectionIds.length > 0) {
      const sectionsParam = sectionIds.join(',');
      const sep = window.location.pathname.indexOf('?') !== -1 ? '&' : '?';
      const sectionUrl = window.location.pathname + sep + 'sections=' + encodeURIComponent(sectionsParam) + '&_=' + Date.now();
      fetch(sectionUrl, {
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (payload) {
          if (payload && typeof payload === 'object' && Object.keys(payload).length > 0) {
            dispatch(payload);
          } else {
            dispatch(null);
          }
        })
        .catch(function () {
          dispatch(null);
        });
    } else {
      dispatch(null);
    }
  }

  function initAddToCartButton(root) {
    const btn = root.querySelector('[data-prescription-add-to-cart]');
    if (!btn) return;

    const cartAddUrl = root.dataset.cartAddUrl || (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url ? Theme.routes.cart_add_url + '.js' : '/cart/add.js');
    const checkbox = root.querySelector('[data-prescription-same]');
    const sameQty = root.querySelector('[data-prescription-same-qty]');
    const odQty = root.querySelector('[data-prescription-od-qty]');
    const oeQty = root.querySelector('[data-prescription-oe-qty]');
    const requiredMessage = root.dataset.prescriptionRequiredMessage || 'Selecione todos os campos obrigatórios antes de continuar.';

    btn.addEventListener('click', function () {
      if (btn.disabled) return;

      const variantId = getVariantId(root);
      if (!variantId) {
        if (typeof window.alert === 'function') window.alert('Variante não encontrada.');
        return;
      }

      const originalText = btn.querySelector('.add-to-cart-text__content');
      const savedText = originalText ? originalText.textContent : '';
      const addedText = (typeof Theme !== 'undefined' && Theme.translations && Theme.translations.added) ? Theme.translations.added : 'Adicionado';
      btn.disabled = true;
      if (originalText) originalText.textContent = addedText;

      const same = checkbox ? checkbox.checked : false;
      let totalItemCount = 0;
      const promises = [];

      if (same) {
        const baseQty = parseInt(sameQty && sameQty.value, 10) || 0;
        if (baseQty < 1) {
          if (typeof window.alert === 'function') window.alert('Informe uma quantidade válida.');
          if (originalText) originalText.textContent = savedText;
          btn.disabled = false;
          return;
        }
        const fields = getScopeFields(root, 'same');
        if (!validateFields(fields, requiredMessage)) {
          if (originalText) originalText.textContent = savedText;
          btn.disabled = false;
          return;
        }
        const qty = baseQty * 2;
        const formData = buildFormData(variantId, qty, fields);
        totalItemCount += qty;
        promises.push(
          fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          }).then(function (r) { return r.json(); })
        );
      } else {
        const qtyOd = Math.max(0, parseInt(odQty && odQty.value, 10) || 0);
        const qtyOe = Math.max(0, parseInt(oeQty && oeQty.value, 10) || 0);
        if (qtyOd < 1 && qtyOe < 1) {
          if (typeof window.alert === 'function') window.alert('Informe ao menos uma quantidade para OD ou OE.');
          if (originalText) originalText.textContent = savedText;
          btn.disabled = false;
          return;
        }
        if (qtyOd > 0) {
          const odFields = getScopeFields(root, 'od');
          if (!validateFields(odFields, requiredMessage)) {
            if (originalText) originalText.textContent = savedText;
            btn.disabled = false;
            return;
          }
          const formDataOd = buildFormData(variantId, qtyOd, odFields);
          totalItemCount += qtyOd;
          promises.push(
            fetch(cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formDataOd
            }).then(function (r) { return r.json(); })
          );
        }
        if (qtyOe > 0) {
          const oeFields = getScopeFields(root, 'oe');
          if (!validateFields(oeFields, requiredMessage)) {
            if (originalText) originalText.textContent = savedText;
            btn.disabled = false;
            return;
          }
          const formDataOe = buildFormData(variantId, qtyOe, oeFields);
          totalItemCount += qtyOe;
          promises.push(
            fetch(cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formDataOe
            }).then(function (r) { return r.json(); })
          );
        }
      }

      if (promises.length === 0) {
        if (originalText) originalText.textContent = savedText;
        btn.disabled = false;
        return;
      }

      Promise.all(promises)
        .then(function (results) {
          const hasError = results.some(function (data) { return data.status && data.status !== 200; });
          if (hasError) {
            const msg = (results[0] && results[0].message) || 'Erro ao adicionar ao carrinho.';
            if (typeof window.alert === 'function') window.alert(msg);
            if (originalText) originalText.textContent = savedText;
          } else {
            fetchSectionsAndDispatch(root, totalItemCount);
            setTimeout(function () {
              if (originalText) originalText.textContent = savedText;
            }, 2000);
          }
        })
        .catch(function () {
          if (originalText) originalText.textContent = savedText;
          if (typeof window.alert === 'function') window.alert('Erro ao adicionar ao carrinho.');
        })
        .finally(function () {
          btn.disabled = false;
        });
    });
  }

  document.querySelectorAll('[id^="jv-prescription-"]').forEach((root) => {
    const checkbox = root.querySelector('[data-prescription-same]');
    const panelSame = root.querySelector('[data-prescription-panel-same]');
    const panelOdOe = root.querySelector('[data-prescription-panel-od-oe]');
    const qtyHidden = root.querySelector('[data-prescription-quantity]');
    const sameQty = root.querySelector('[data-prescription-same-qty]');
    const odQty = root.querySelector('[data-prescription-od-qty]');
    const oeQty = root.querySelector('[data-prescription-oe-qty]');

    initGrauPickers(root);
    initHeaderTooltipPosition(root);
    initFormInject(root);
    initAddToCartButton(root);

    if (!panelSame || !panelOdOe) return;

    function toggleControls(scope, disabled) {
      if (!scope) return;
      scope.querySelectorAll('select, input[type="number"], .jv-prescription-grau').forEach((el) => {
        if (el.classList && el.classList.contains('jv-prescription-grau')) {
          const trigger = el.querySelector('[data-grau-trigger]');
          const input = el.querySelector('[data-grau-input]');
          if (trigger) trigger.disabled = disabled;
          if (input) input.disabled = disabled;
        } else {
          el.disabled = disabled;
        }
      });
    }

    function setPanelVisibility() {
      if (!checkbox) {
        panelSame.hidden = true;
        panelOdOe.hidden = false;
        toggleControls(panelSame, true);
        toggleControls(panelOdOe, false);
        updateQuantity();
        return;
      }

      const same = checkbox.checked;
      panelSame.hidden = !same;
      panelOdOe.hidden = same;
      toggleControls(panelSame, !same);
      toggleControls(panelOdOe, same);
      updateQuantity();
    }

    function updateQuantity() {
      if (!qtyHidden) return;
      let total = 1;
      if (checkbox && checkbox.checked) {
        const n = parseInt(sameQty?.value, 10) || 0;
        total = Math.max(1, n * 2);
      } else {
        const od = parseInt(odQty?.value, 10) || 0;
        const oe = parseInt(oeQty?.value, 10) || 0;
        total = Math.max(1, od + oe);
      }
      qtyHidden.value = String(total);
    }

    if (checkbox) checkbox.addEventListener('change', setPanelVisibility);

    if (sameQty) sameQty.addEventListener('input', updateQuantity);
    if (sameQty) sameQty.addEventListener('change', updateQuantity);
    if (odQty) odQty.addEventListener('input', updateQuantity);
    if (odQty) odQty.addEventListener('change', updateQuantity);
    if (oeQty) oeQty.addEventListener('input', updateQuantity);
    if (oeQty) oeQty.addEventListener('change', updateQuantity);

    setPanelVisibility();
  });
})();
